export default {
  data() {
    return {
      searchSchema: [
        {
          label: '大区',
          type: 'input',
          itemName: 'name',
          allowClear: true,
        },
        {
          label: '编辑人ITCode',
          type: 'input',
          itemName: 'userCode',
          allowClear: true,
        },
        {
          label: '业务类型选择',
          type: 'select',
          itemName: 'pid',
          selectList: [],
          placeholder: '全部',
          allowClear: true,
        },
      ],
      searchForm: {
        name: '',
        userCode: '',
        pid: '',
      },
      pageData: {
        pageSize: 10,
        current: 1,
        total: 0,
        showTotal: total => `共${total}条`,
      },
      tableData: [],
      tableColumns: [
        {
          fixed: 'left',
          title: '序号',
          width: 80,
          customRender: (text, record, index) => {
            return (
              (this.pageData.current - 1) * this.pageData.pageSize + index + 1
            )
          },
        },
        {
          title: '大区',
          width: 120,
          dataIndex: 'name',
        },
        {
          title: '所属业务类型',
          width: 140,
          dataIndex: 'pname',
        },
        {
          title: '编辑时间',
          width: 220,
          dataIndex: 'updateTime',
        },
        {
          title: '编辑人ITCode',
          width: 180,
          dataIndex: 'userCode',
        },
        {
          title: '编辑人名称',
          width: 180,
          dataIndex: 'userName',
        },
        {
          title: '操作',
          width: 140,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
    }
  },
  methods: {
    // 查询
    handleSearch(data) {
      this.searchForm = { ...this.searchForm, ...data }
      this.pageData.current = 1
      this._getTableData()
    },
    // 点击分页按钮
    handleClickPage({ current, pageSize }) {
      this.pageData = { ...this.pageData, current, pageSize }
      this._getTableData()
    },
  },
}
